
import SecuritySettings from "../components/admin/SecuritySettings";

export default function AdminSettings() {
  return (
    <div>
      <SecuritySettings />
    </div>
  );
}
